import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { useOrg } from '../organization/useOrg'

export const mayManageAliceCardProgram = (org: OrganizationDetailFragment | null | undefined) => {
  return Boolean(org?.aliceCardProgram.companyAccount)
}

// Context-based wrapper for backward compatibility
export const useMayManageAliceCardProgram = () => {
  const org = useOrg()
  return mayManageAliceCardProgram(org)
}
